// src/services/auth.js
import { api } from './api';

export const authService = {
    login: (email, password) => api.post('/auth/login', { email, password }),
    logout: () => api.post('/auth/logout')
};